import { PROFILE_FUNCTIONS } from '../config/functionRoutes';
import { getFunctions, httpsCallable } from 'firebase/functions';

export interface ClaimProfileRequest {
  targetProfileDocId: string;
  targetPersonId: number | null;
  targetName: string;
}

export interface UnclaimProfileRequest {
  profileDocId: string;
  personId: number | null;
  name: string;
  reason?: string;
  keepPersonalDetails?: boolean;
}

export interface ClaimProfileResponse {
  success: boolean;
  taskId?: string;
  error?: string;
}

/**
 * Submit a request to claim a runner profile ("This is me!")
 * Creates an admin task for review.
 */
export async function submitClaimProfileRequest(
  request: ClaimProfileRequest
): Promise<ClaimProfileResponse> {
  const functions = getFunctions(undefined, 'europe-west1');
  const claimProfileFn = httpsCallable<ClaimProfileRequest, ClaimProfileResponse>(
    functions,
    PROFILE_FUNCTIONS.claim
  );
  
  const result = await claimProfileFn(request);
  return result.data;
}

/**
 * Submit a request to unclaim/unlink a runner profile ("This is not me!")
 * Creates an admin task for review.
 */
export async function submitUnclaimProfileRequest(
  request: UnclaimProfileRequest
): Promise<ClaimProfileResponse> {
  const functions = getFunctions(undefined, 'europe-west1');
  const unclaimProfileFn = httpsCallable<UnclaimProfileRequest, ClaimProfileResponse>(
    functions,
    PROFILE_FUNCTIONS.unclaim
  );
  
  const result = await unclaimProfileFn(request);
  return result.data;
}
